import React, { useContext } from 'react';
import NavContext from "../NavContext";
import { Container } from "../../../../index";
var HeaderToolsRecherche = React.forwardRef(function (_a, ref) {
    var name = _a.name, onChange = _a.onChange, onBlur = _a.onBlur, onClickRecherche = _a.onClickRecherche, _b = _a.placeHolder, placeHolder = _b === void 0 ? "Rechercher" : _b, _c = _a.titreBouton, titreBouton = _c === void 0 ? "Rechercher" : _c;
    var _d = useContext(NavContext), openModaleRecherche = _d.openModaleRecherche, setOpenModaleRecherche = _d.setOpenModaleRecherche;
    var classModale = "fr-header__search fr-modal";
    if (openModaleRecherche) {
        classModale += " fr-modal--opened";
    }
    var onClick = function (e) {
        setOpenModaleRecherche(false);
        if (onClickRecherche) {
            onClickRecherche(e);
        }
    };
    return (React.createElement("div", { className: classModale, id: "modal-bouton-recherche" },
        React.createElement(Container, { taille: "lg" },
            React.createElement("button", { className: "fr-btn--close fr-btn", "aria-controls": "modal-bouton-recherche", title: "Fermer", onClick: function () { return setOpenModaleRecherche(false); } }, "Fermer"),
            React.createElement("div", { className: "fr-search-bar", id: "bouton-recherche", role: "search" },
                React.createElement("label", { className: "fr-label", htmlFor: "bouton-recherche-input" }, "Rechercher"),
                React.createElement("input", { 
                    // @ts-ignore
                    ref: ref, name: name, onChange: onChange, onBlur: onBlur, className: "fr-input", placeholder: placeHolder, type: "search", id: "bouton-recherche-input" }),
                React.createElement("button", { className: "fr-btn", title: titreBouton, onClick: onClick, onKeyDown: function (e) { return e.key === 'Enter' ? onClick :
                        ''; } }, titreBouton)))));
});
export default HeaderToolsRecherche;
